import { useState } from "react";
import { toast } from "sonner";
import { Phone, Mail, MessageSquare } from "lucide-react";
import { api } from "../lib/api";
import { Reveal } from "../components/Reveal";

export default function Contact() {
  const [form, setForm] = useState({ name: "", email: "", phone: "", interest: "", message: "" });
  const [submitting, setSubmitting] = useState(false);

  const update = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      await api.post("/contact", form);
      toast.success("Thanks! We'll be in touch shortly.");
      setForm({ name: "", email: "", phone: "", interest: "", message: "" });
    } catch (err) {
      toast.error("Something went wrong. Please try again.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="pt-32" data-testid="contact-page">
      <section className="mx-auto grid max-w-7xl gap-14 px-6 pb-24 lg:grid-cols-[0.9fr_1.1fr] lg:px-12">
        <Reveal>
          <span className="text-sm font-bold uppercase tracking-widest text-crimson">Get in touch</span>
          <h1 className="mt-3 font-display text-5xl font-black leading-none tracking-tighter text-ink sm:text-6xl">
            Questions about leasing? Talk to us.
          </h1>
          <p className="mt-6 max-w-md text-lg text-muted-foreground">
            Our team is here 24/7 to help you find the right iPhone and the right lease.
          </p>
          <div className="mt-8 space-y-4">
            <a href="tel:7709055829" data-testid="contact-phone" className="flex items-center gap-3 text-base font-medium text-ink hover:text-crimson">
              <span className="flex h-10 w-10 items-center justify-center rounded-full bg-crimson/10"><Phone className="h-5 w-5 text-crimson" /></span>
              (770) 905-5829
            </a>
            <div className="flex items-center gap-3 text-base font-medium text-ink">
              <span className="flex h-10 w-10 items-center justify-center rounded-full bg-crimson/10"><MessageSquare className="h-5 w-5 text-crimson" /></span>
              Call or text — 24/7 support
            </div>
            <div className="flex items-center gap-3 text-base font-medium text-ink">
              <span className="flex h-10 w-10 items-center justify-center rounded-full bg-crimson/10"><Mail className="h-5 w-5 text-crimson" /></span>
              We reply fast to every message
            </div>
          </div>
        </Reveal>

        <Reveal delay={0.1}>
          <form onSubmit={submit} data-testid="contact-form" className="rounded-3xl border border-line bg-white p-8 shadow-xl md:p-10">
            <div className="grid gap-5 sm:grid-cols-2">
              <div>
                <label className="text-sm font-bold text-ink">Name</label>
                <input required value={form.name} onChange={update("name")} data-testid="contact-name" className="mt-2 w-full rounded-xl border border-line px-4 py-3 outline-none transition-colors focus:border-crimson" />
              </div>
              <div>
                <label className="text-sm font-bold text-ink">Phone</label>
                <input value={form.phone} onChange={update("phone")} data-testid="contact-phone-input" className="mt-2 w-full rounded-xl border border-line px-4 py-3 outline-none transition-colors focus:border-crimson" />
              </div>
            </div>
            <div className="mt-5">
              <label className="text-sm font-bold text-ink">Email</label>
              <input required type="email" value={form.email} onChange={update("email")} data-testid="contact-email" className="mt-2 w-full rounded-xl border border-line px-4 py-3 outline-none transition-colors focus:border-crimson" />
            </div>
            <div className="mt-5">
              <label className="text-sm font-bold text-ink">I'm interested in</label>
              <input value={form.interest} onChange={update("interest")} placeholder="e.g. iPhone 15 Pro lease" data-testid="contact-interest" className="mt-2 w-full rounded-xl border border-line px-4 py-3 outline-none transition-colors focus:border-crimson" />
            </div>
            <div className="mt-5">
              <label className="text-sm font-bold text-ink">Message</label>
              <textarea required rows={4} value={form.message} onChange={update("message")} data-testid="contact-message" className="mt-2 w-full resize-none rounded-xl border border-line px-4 py-3 outline-none transition-colors focus:border-crimson" />
            </div>
            <button disabled={submitting} type="submit" data-testid="contact-submit" className="mt-6 w-full rounded-full bg-ink py-4 font-bold text-white transition-colors hover:bg-crimson disabled:opacity-60">
              {submitting ? "Sending…" : "Send message"}
            </button>
          </form>
        </Reveal>
      </section>
    </div>
  );
}
